<!--站点/管理页 添加/编辑站点表单-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            {{ form.id ? form.name + "--------" + "id：" + form.id : "添加站点" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form
                label-width="7vw"
                :model="form"
                ref="form"
                :style="{ color: theme.pageFontColor }"
            >
                <el-form-item label="站点名称" :rules="[{ required: true }]">
                    <el-input type="text" v-model="form.name">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="简介">
                    <el-input
                        v-model="form.info"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="站点照片">
                    <upload-img @upload="upload" :imgList="form.pic" :limit="30" :site="true" />
                </el-form-item>
                <el-form-item label="服务标签">
                    <el-select
                        v-model="form.tag"
                        multiple
                        filterable
                        allow-create
                        default-first-option
                        placeholder="请选择服务标签"
                        style="width:100%"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in Tags"
                            :key="index"
                            :label="item.value"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="省/市/区" :rules="[{ required: true }]">
                    <v-row>
                        <v-col cols="4" md="4">
                            <el-select
                                v-model="form.area_code"
                                filterable
                                allow-create
                                default-first-option
                                clearable
                                placeholder="省/江西省"
                            >
                                <el-option
                                    v-for="(item, index) in allArea"
                                    :key="index"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </v-col>
                        <v-col cols="4" md="4">
                            <el-input
                                clearable
                                placeholder="城市/南昌市"
                                v-model="form.city_code"
                            ></el-input>
                        </v-col>
                        <v-col cols="4" md="4">
                            <el-input
                                clearable
                                placeholder="区/西湖区"
                                v-model="form.area"
                            ></el-input>
                        </v-col>
                    </v-row>
                </el-form-item>
                <el-form-item label="地图定位" :rules="[{ required: true }]">
                    <el-amap-search-box
                        class="search-box"
                        :search-option="searchOption"
                        :on-search-result="onSearchResult"
                        style="width:100%"
                    ></el-amap-search-box>
                    <div class="toolbar mt-1" :style="{ color: theme.pageFontColor }">
                        <el-input type="text" v-model="placeNames">
                            <template slot="prepend">
                                <div>
                                    地名
                                </div>
                            </template>
                        </el-input>
                        <el-input type="text" v-model="form.address">
                            <template slot="prepend">
                                地址
                            </template>
                        </el-input>
                        <el-input type="text" v-model="form.lng" style="width:49%;">
                            <template slot="prepend">
                                经度
                            </template>
                        </el-input>
                        <el-input type="text" v-model="form.lat" style="margin-left:2%;width:49%">
                            <template slot="prepend">
                                纬度
                            </template>
                        </el-input>
                    </div>
                    <div class="amap-page-container" id="map">
                        <el-amap
                            vid="amapDemo"
                            :center="center"
                            :zoom="13"
                            class="amap-demo"
                            :events="events"
                        >
                            <el-amap-marker
                                v-for="(marker, index) in markers"
                                :key="index"
                                :position="marker.position"
                            ></el-amap-marker>
                        </el-amap>
                    </div>
                </el-form-item>
                <el-form-item label="价格" :rules="[{ required: true }]" style="margin-top:3em">
                    <price-table
                        :applyPrice="editSite.price"
                        @modify="modifyPrice"
                        :disabled="false"
                    />
                </el-form-item>
                <!-- <el-form-item label="互联互通">
                    <select-cec :width="'100%'" :cecId="form.cec_id" @chooseCec="chooseCec" />
                </el-form-item>
                <el-form-item label="互联互通站点ID">
                    <el-input type="text" v-model="form.cec_station_id">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item> -->
                <el-form-item label="运营商ID">
                    <el-input type="text" v-model="form.operator_id">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
				<el-form-item v-if="role === 0" label="所属平台" :rules="[{ required: true }]">
				    <select-platform
						v-if="isPlatform"
				    	@choose="choosePlatformId"
				        :selectPlatform="form.platform_id"
				        :width="'100%'"
				    />
				</el-form-item>
                <el-form-item label="站点状态" :rules="[{ required: true }]">
                    <el-radio
                        v-model="form.status"
                        v-for="(item, index) in status"
                        :key="index"
                        :label="item.id"
                    >
                        {{ item.text }}
                    </el-radio>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="apply()" class="float-lg-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import util from "@/util";
import Public from "@/public"
import PriceTable from "@/components/Table/PriceTable";
import UploadImg from "@/components/UploadImg";
import SelectCec from "@/components/SelectCec";
import SelectPlatform from "@/components/SelectPlatform";
import store from "@/store";
import { mapState } from "vuex";

export default {
    name: "EditSite",
    data() {
        let self = this;
        return {
			isPlatform: true,
            priceTable: true,
            form: {
                id: null,
                name: "", //站点名称
                area_code: "", //站点位于的省份
                city_code: "", //站点位于的市
                tag: [], //服务标签
                info: "", //站点简介
                lng: null, //经度
                lat: null, //纬度
                operator_id: null, //运营商ID
                address: "", //地址
                price: [], //价格
                pic: [], //站点图片,
                status: 0, //站点状态
                cec_id: null, //互联互通id
                cec_station_id: null, //互联互通站点id
                connector_count: null, //枪数量
                free_count: null,
				platform_id: null, //平台
            },
            searchOption: {
                city: "南昌",
                citylimit: false,
            },
            loaded: false,
            events: {
                click(e) {
                    self.clickMap(e);
                },
            },
            markers: [], //地图显示的图标
            center: [115.904539, 28.686507], //地图中心点位置 经度，纬度
            placeNames: "", //地名
            Tags: [
                //服务标签
                { value: "厕所", id: 0 },
                { value: "餐厅", id: 1 },
                { value: "雨棚", id: 2 },
                { value: "限时免费停车", id: 3 },
                { value: "休息室", id: 4 },
            ],
            status: [
                //站点状态
                { id: 0, text: "未知" },
                { id: 1, text: "建设中" },
                { id: 5, text: "关闭下线" },
                { id: 6, text: "维护中" },
				{ id: 7, text: "内部站点" },
                { id: 50, text: "正常" },
            ],
            cecInfo: null,
        };
    },
    props: {
        editSite: Object,
        isAdd: Boolean,
        allArea: Array,
    },
    watch: {
        editSite: {
            handler(val) {
                this.form.pic = val.pic;
            },
            deep: true,
        },
		form() {
			console.log(this.form)
		    this.isPlatform = false;
		    this.$nextTick(() => {
		        this.isPlatform = true;
		    });
		},
    },
    created() {
        this.firstEntry();
    },
    components: {
        PriceTable,
        UploadImg,
        SelectCec,
		SelectPlatform
    },
    computed: {
        ...mapState(["theme", "contactInfo","platform_id","role"]),
    },
    methods: {
        chooseCec(cecId) {
            this.form["cec_id"] = cecId;
        },
		/*选择平台*/
		choosePlatformId(e) {
			// console.log(e)
			this.form.platform_id = e
		},
        /*首次进入*/
        firstEntry() {
            let form = {};
            Object.keys(this.form).forEach(key => {
                form[key] = this.editSite[key]
            });
			Object.keys(this.form).forEach(key => {
			    this.form[key] = form[key]
			});
            if (!this.form.lng && !this.form.lat) {
                this.form.lng = 115.88119;
                this.form.lat = 28.681314;
            }
			if(this.isAdd && this.role !== 0) {
				this.form.platform_id = this.platform_id;
			}
            this.displayName(this.form.lng, this.form.lat);
            this.center = [this.form.lng, this.form.lat];
            this.markers = [];
            this.markers.push({
                position: [this.form.lng, this.form.lat],
            });
        },
        /*选择需要上传的图片*/
        upload(data) {
            if (!data) {
                return;
            }
            this.form.pic = this.JsonData(data);
        },
        /*修改价格*/
        modifyPrice(data) {
            this.form.price = data;
        },
        /*点击地图选择地点*/
        clickMap(e) {
            let { lng, lat } = e.lnglat;
            this.form.lng = lng;
            this.form.lat = lat;
            this.displayName(this.form.lng, this.form.lat, true);
            this.markers = [];
            this.markers.push({
                position: [this.form.lng, this.form.lat],
            });
        },
        /*搜索地点*/
        onSearchResult(pois) {
            this.form.lng = pois[0].lng;
            this.form.lat = pois[0].lat;
            this.displayName(this.form.lng, this.form.lat, true);
            this.center = [this.form.lng, this.form.lat];
            this.markers = [];
            this.markers.push({
                position: [this.form.lng, this.form.lat],
            });
        },
        /*通过经纬度显示完整地名*/
        displayName(lng, lat, isClickMap) {
            const geocoder = new AMap.Geocoder({
                radius: 1000,
                extensions: "all",
            });
            let that = this;
            geocoder.getAddress([lng, lat], function(status, result) {
                if (status === "complete" && result.info === "OK") {
                    if (result && result.regeocode) {
                        if (isClickMap || that.isAdd) {
                            that.form.address = result.regeocode.formattedAddress;
                        }
                        if (!result.regeocode.aois[0]) {
                            that.placeNames = null;
                        } else {
                            that.placeNames = result.regeocode.aois[0].name;
                        }
                        that.$nextTick();
                    }
                }
            });
        },
        /*确定*/
        apply() {
            let form = Object.assign({}, this.form);
            delete form.id;
            delete form.info;
            delete form.pic;
            delete form.tag;
            delete form.city_code;
            delete form.cec_id;
            delete form.cec_station_id;
            delete form.operator_id;
            delete form.connector_count;
            delete form.free_count;
            delete form.status;
            let nullKeyArr = Object.keys(form).filter(key => !form[key]);
            if (nullKeyArr.length > 0 || this.form["status"] == undefined) {
                let utilText = "";
                for (let i1 = 0; i1 < nullKeyArr.length; i1++) {
                    if (i1 == nullKeyArr.length - 1) {
                        utilText = utilText + this.utilText(nullKeyArr[i1]);
                    } else {
                        utilText = utilText + this.utilText(nullKeyArr[i1]) + "、";
                    }
                }
                if (this.form["status"] == undefined) {
                    if (utilText != "") {
                        utilText = utilText + "、状态";
                    } else {
                        utilText = "状态";
                    }
                }
                util.ShowTip(utilText + "不能为空", 3);
                return;
            }
            if (this.form.tag == undefined) {
                this.form.tag = [];
            }
            // this.form.pic.splice(0,1)
			Object.keys(this.form).forEach(key => {
				 if (key == "name" || key == "area_code" || key == "city_code" || key == "info" || key == "address") {
				    this.form[key] = Public.removeSpace(this.form[key])
				 }
			})
            let params = {
                postData: { stationInfo: this.form },
                callback: () => {
                    this.$emit("refresh");
                    store.commit("SET_IMG", null);
                    this.cancel();
                },
            };
            if (this.isAdd) {
                store.dispatch("addSite", params);
            } else {
                store.dispatch("updateStation", params);
            }
        },
        utilText(key) {
            let text = "";
            if (key == "name") {
                text = "站点名称";
            } else if (key == "lng") {
                text = "经度";
            } else if (key == "lat") {
                text = "纬度";
            } else if (key == "area_code") {
                text = "省";
            } else if (key == "address") {
                text = "地址";
            } else if (key == "price") {
                text = "价格";
            } else if (key == "platform_id") {
				text = "平台";
			}
            return text;
        },
        /*取消*/
        cancel() {
            //解决地图记载显示空白
            let map = document.getElementById("map");
            map.remove();
            this.$emit("noEditor");
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
    },
};
</script>
<style>
.search-box {
    position: absolute;
}
.amap-page-container {
    width: 100%;
    height: 450px;
}
</style>
